import { AdBanner } from '@techminds/ad-banner';
import { PageType } from '@travel-ui/my-widget';
import { RollingBanner, BannerPosition } from '@techminds/ad-banner';
import classNames from 'classnames/bind';
import { useRouter } from 'next/router';
import { useState } from 'react';

import PopupAd from 'common/PopupAd';
import Footer from 'common/footer';
import GNB from 'common/header';
import ModalContainer from 'common/modal/index';
import MyWidget from 'common/myWidget';
import SearchBox from 'common/searchBox';
import SideBanner from 'common/sideBanner';
import UnsupportedBrowser from 'common/unsupportedBrowser';
import config from 'config/index';
import { InfoParamsContextProvider } from 'contexts/infoParams';
import {
  IModal,
  Modal,
  ModalFuncContext,
  ModalPosition,
} from 'contexts/modalFunc';
import { useSearchParamsContext } from 'contexts/searchParams';
import useSearchInitialize from 'hooks/useSearchInitialize';
import Intro from './common/Intro';
import LineBanner from './common/lineBanner';
import TextBanner from './common/textBanner';
import styles from './index.module.scss';
import Normal from './normal';

const cx = classNames.bind(styles);
const adSlotInfo = {
  adUnitId: 'm_flight_home',
  uct: 'KR',
};

const flickingCardContents = [
  {
    title: '설레는 여행의 시작',
    subtitle: '네이버 항공권!',
  },
  {
    title: '항공권 구매하면',
    subtitle: '호텔 최대 15% 할인',
    url: `${config.eventpromotion}/promotion/secretcoupon`,
    nClickCode: 'mai.event1',
  },
  {
    title: '매일 진행되는',
    subtitle: '네이버페이 적립이벤트',
    url: `${config.eventpromotion}?code=flight`,
    nClickCode: 'mai.event2',
  },
  {
    title: '해외 출장 항공은',
    subtitle: '첫 예약 5,000원 적립',
    url: `${config.eventpromotion}/promotion/biztripfirst`,
    nClickCode: 'mai.event3',
  },
];

const adUnitIds = [
  'tm_travel_flight_main_rolling_image_banner_0',
  'tm_travel_flight_main_rolling_image_banner_1',
  'tm_travel_flight_main_rolling_image_banner_2',
  'tm_travel_flight_main_rolling_image_banner_3',
  'tm_travel_flight_main_rolling_image_banner_4',
  'tm_travel_flight_main_rolling_image_banner_5',
  'tm_travel_flight_main_rolling_image_banner_6',
  'tm_travel_flight_main_rolling_image_banner_7',
  'tm_travel_flight_main_rolling_image_banner_8',
  'tm_travel_flight_main_rolling_image_banner_9',
].slice(0, config.maxRollingBannerCount);

function Main() {
  const router = useRouter();
  const { query } = router;
  const { searchDetail } = query;

  const [modal, setModal] = useState<IModal>({
    type: Modal.NULL,
    position: ModalPosition.MAIN,
  });

  const { searchParams } = useSearchParamsContext();

  useSearchInitialize(router, setModal);

  return (
    <ModalFuncContext.Provider value={setModal}>
      <div
        className={`flights ${cx('Main')}`}
        data-container="main"
      >
        <main>
          <InfoParamsContextProvider searchParams={searchParams}>
            <UnsupportedBrowser />
            <GNB />
            <Intro items={flickingCardContents} />
            <div className={cx('searchbox')}>
              <div className={cx('inner')}>
                <SearchBox
                  disablePriceAlert
                  expandMultiCity
                  showSeat={Boolean(+(searchDetail as any))}
                />
              </div>
            </div>
            <TextBanner />
            <RollingBanner
              adUnitIds={adUnitIds}
              position={BannerPosition.MAIN}
            />
            <div className={cx('my_widget_container')}>
              <div className={cx('inner')}>
                <MyWidget pageType={PageType.MAIN} nClickCodePrefix="mai." />
              </div>
            </div>
            <Normal />
            <div className={cx('ad')}>
              <div className={cx('inner')}>
                <AdBanner adSlotInfo={adSlotInfo} />
              </div>
            </div>
            <Footer />
            <ModalContainer modal={modal} setModal={setModal} />
          </InfoParamsContextProvider>
        </main>
        <LineBanner />
        <SideBanner />
        <PopupAd />
      </div>
    </ModalFuncContext.Provider>
  );
}

export default Main;
